import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { transactionShape } from '../../../utils/propTypes';
import {
    EmvioActionsPopover,
    EmvioConfirmation,
    EmvioLoadingSpinner as LoadingSpinner
} from '@nexio/emvio-util-ui';
import { getDoesUserHaveWriteAccessForMerchant } from '../../Self/selfEntity';
import {
    getVoidErrorMessageById,
    getIsVoidLoadingById,
    getIsVoidSuccessfulById
} from '../../Void/voidEntity';
import {
    getCaptureErrorMessageById,
    getIsCaptureLoadingById,
    getIsCaptureSuccessfulById
} from '../../Capture/captureEntity';
import { voidTransaction } from '../../Void/voidActions';
import { captureTransaction } from '../../Capture/captureActions';
import { get } from 'lodash';
import './Actions.scss';
import { toastIfError } from '../../../utils/toast';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { toast } from 'react-toastify';

export class Actions extends Component {
    static propTypes = {
        captureError: PropTypes.string,
        doesUserHaveWriteAccess: PropTypes.bool,
        isCaptureLoading: PropTypes.bool,
        isCaptureSuccessful: PropTypes.bool,
        isVoidLoading: PropTypes.bool,
        isVoidSuccessful: PropTypes.bool,
        onCaptureTransaction: PropTypes.func,
        onRefetch: PropTypes.func,
        onVoidTransaction: PropTypes.func,
        transaction: transactionShape.isRequired,
        voidError: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.handleOpenPopover = this.handleOpenPopover.bind(this);
        this.handleOpenApproveConfirmation = this.handleOpenApproveConfirmation.bind(this);
        this.handleOpenDeclineConfirmation = this.handleOpenDeclineConfirmation.bind(this);

        this.actionsRefString = `actions${props.transaction.id}Ref`;
        this[this.actionsRefString] = React.createRef();

        this.approveRefString = `approve${props.transaction.id}Ref`;
        this[this.approveRefString] = React.createRef();

        this.declineRefString = `decline${props.transaction.id}Ref`;
        this[this.declineRefString] = React.createRef();

        this.buttonRefString = `button${props.transaction.id}Ref`;
        this[this.buttonRefString] = React.createRef();
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'captureError');
        toastIfError(prevProps, this.props, 'voidError');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isVoidSuccessful')) {
            toast('Void Successful!', { type: 'success' });
            this.props.onRefetch();
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isCaptureSuccessful')) {
            toast('Capture Successful!', { type: 'success' });
            this.props.onRefetch();
        }
    }

    handleOpenPopover() {
        this[this.actionsRefString].current.openPopover(this[this.buttonRefString].current);
    }

    handleOpenApproveConfirmation() {
        this[this.approveRefString].current.openPopover(this[this.buttonRefString].current);
    }

    handleOpenDeclineConfirmation() {
        this[this.declineRefString].current.openPopover(this[this.buttonRefString].current);
    }

    render() {
        const accessDeniedText = 'Insufficient access rights';

        return (
            <div className="action-cell">
                <div className="popover-btn" onClick={this.handleOpenPopover}>
                    {this.props.isVoidLoading || this.props.isCaptureLoading ?
                        <LoadingSpinner size="small" relative ref={this[this.buttonRefString]} /> :
                        <span className="icon-ellipsis" ref={this[this.buttonRefString]} />}
                </div>
                <EmvioConfirmation
                    buttonText="Approve"
                    onConfirm={this.props.onCaptureTransaction(this.props.transaction)}
                    ref={this[this.approveRefString]}
                    text="Are you sure you want to approve this transaction?"
                />
                <EmvioConfirmation
                    buttonText="Decline"
                    onConfirm={this.props.onVoidTransaction(this.props.transaction)}
                    ref={this[this.declineRefString]}
                    text="Are you sure you want to decline this transaction?"
                />
                <EmvioActionsPopover
                    actions={[{
                        onClick: this.handleOpenApproveConfirmation,
                        disabled: !this.props.doesUserHaveWriteAccess,
                        tooltip: !this.props.doesUserHaveWriteAccess ? accessDeniedText : '',
                        title: 'Approve'
                    }, {
                        onClick: this.handleOpenDeclineConfirmation,
                        disabled: !this.props.doesUserHaveWriteAccess,
                        tooltip: !this.props.doesUserHaveWriteAccess ? accessDeniedText : '',
                        title: 'Decline'
                    }]}
                    ref={this[this.actionsRefString]}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const id = get(ownProps.transaction, 'id');
    const merchantId = get(ownProps.transaction, 'merchantId');

    return {
        captureError: getCaptureErrorMessageById(state, id),
        doesUserHaveWriteAccess: getDoesUserHaveWriteAccessForMerchant(state, merchantId),
        isCaptureLoading: getIsCaptureLoadingById(state, id),
        isCaptureSuccessful: getIsCaptureSuccessfulById(state, id),
        isVoidLoading: getIsVoidLoadingById(state, id),
        isVoidSuccessful: getIsVoidSuccessfulById(state, id),
        voidError: getVoidErrorMessageById(state, id)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCaptureTransaction: (transaction) => () => dispatch(captureTransaction(transaction)),
        onVoidTransaction: (transaction) => () => dispatch(voidTransaction(transaction))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
